import {AxiosError} from 'axios';
import {useMutation} from '@tanstack/react-query';
import {api} from '@eksab/api';
import {MyPower} from '@eksab/features/store/badges/types';
type PowerConsumptionTypes =
  | {
      competition_entry_id: number;
    }
  | {
      news_item_id: number;
    };
type PowerConsumptionParams = PowerConsumptionTypes & {id: number};
export function useConsumePowerMutation() {
  return useMutation<MyPower, AxiosError, PowerConsumptionParams>(({id, ...rest}) =>
    api.post(`v1/user-powers/${id}/consume`, rest),
  );
}
